import request from "@/utils/request";
// 登录接口
export function login(data) {
    return request({
        url: "/login",
        method: "post",
        data,
    });
}
// 退出登录
export function logout(data) {
    return request({
        url: "/logout",
        method: "post",
        data,
    });
}
// 首页统计
export function home_statistics(data) {
    return request({
        url: "/home/statistics",
        method: "get",
        params: data,
    });
}
// 首页统计-查询列表数据
export function home_query_record(data) {
    return request({
        url: "/home/query_record",
        method: "get",
        params: data,
    });
}
// 获取公司名，短信数量，剩余溯源码数量
export function home_get_count(data) {
    return request({
        url: "/home/get_count",
        method: "get",
        params: data,
    });
}
// 查询模板列表
export function template_query_template(data) {
    return request({
        url: "/template/query_template",
        method: "get",
        params: data,
    });
}
// 修改查询模板使用状态
export function template_modify_use(data) {
    return request({
        url: "/template/modify_use",
        method: "post",
        data,
    });
}
// 产品模板列表
export function template_result_template(data) {
    return request({
        url: "/template/result_template",
        method: "get",
        params: data,
    });
}
// diy模板列表
export function template_diy_list(data) {
    return request({
        url: "/template/diy/list",
        method: "get",
        params: data,
    });
}
// 复制产品模板到diy
export function template_copy_result(data) {
    return request({
        url: "/template/copy_result",
        method: "post",
        data,
    });
}
// 产品列表
export function product_list(data) {
    return request({
        url: "/product/list",
        method: "get",
        params: data,
    });
}
// 新增或者修改产品
export function product_save(data) {
    return request({
        url: "/product/save",
        method: "post",
        data,
    });
}
// 复制diy模板
export function template_diy_copy(data) {
    return request({
        url: "/template/diy/copy",
        method: "post",
        data,
    });
}
// 创建或修改DIY模板
export function template_diy_save(data) {
    return request({
        url: "/template/diy/save",
        method: "post",
        data,
    });
}
// DIY模板的页面管理列表
export function template_diy_manage(data) {
    return request({
        url: "/template/diy/manage",
        method: "get",
        params: data,
    });
}
// 删除diy模板
export function template_diy_del(data) {
    return request({
        url: "/template/diy/del",
        method: "post",
        data,
    });
}
// DIY模板的页面管理-保存修改
export function template_diy_save_manage(data) {
    return request({
        url: "/template/diy/save_manage",
        method: "post",
        data,
    });
}
// DIY模板的页面管理-删除
export function template_diy_del_manage(data) {
    return request({
        url: "/template/diy/del_manage",
        method: "post",
        data,
    });
}
// 获取产品分类列表
export function product_type_list(data) {
    return request({
        url: "/product/type/list",
        method: "get",
        params: data,
    });
}
// 创建或修改产品分类
export function product_type_save(data) {
    return request({
        url: "/product/type/save",
        method: "post",
        data,
    });
}
// 删除产品分类
export function product_type_del(data) {
    return request({
        url: "/product/type/del",
        method: "post",
        data,
    });
}
// 产品属性列表
export function product_attribute_list(data) {
    return request({
        url: "/product/attribute/list",
        method: "get",
        params: data,
    });
}
// 创建或修改产品属性
export function product_attribute_save(data) {
    return request({
        url: "/product/attribute/save",
        method: "post",
        data,
    });
}
// 删除产品属性
export function product_attribute_del(data) {
    return request({
        url: "/product/attribute/del",
        method: "post",
        data,
    });
}
// 获取预警信息
export function home_news_list(data) {
    return request({
        url: "/home/news_list",
        method: "get",
        params: data,
    });
}
// 删除预警信息
export function home_delete_info(data) {
    return request({
        url: "/home/delete_info",
        method: "post",
        data,
    });
}
// 查看预警详情
export function home_news_info(data) {
    return request({
        url: "/home/news_info",
        method: "get",
        params: data,
    });
}
// 批次列表
export function batch_list(data) {
    return request({
        url: "/batch/list",
        method: "get",
        params: data,
    });
}
// 删除批次
export function batch_delete(data) {
    return request({
        url: "/batch/delete",
        method: "post",
        data,
    });
}
// 批次详情
export function batch_info(data) {
    return request({
        url: "/batch/info",
        method: "post",
        data,
    });
}
// 创建或修改批次
export function batch_save(data) {
    return request({
        url: "/batch/save",
        method: "post",
        data,
    });
}
// 语音播报开关
export function batch_change(data) {
    return request({
        url: "/batch/change",
        method: "post",
        data,
    });
}
// 溯源码生成记录列表
export function qrcode_count_list(data) {
    return request({
        url: "/qrcode/count/list",
        method: "get",
        params: data,
    });
}
// 产品详情
export function product_info(data) {
    return request({
        url: "/product/info",
        method: "get",
        params: data,
    });
}
// 切换模板接口（产品）
export function product_change_template(data) {
    return request({
        url: "/product/change_template",
        method: "post",
        data,
    });
}
// 删除产品
export function product_delete(data) {
    return request({
        url: "/product/delete",
        method: "post",
        data,
    });
}
// 产品样册列表
export function product_samplebook_list(data) {
    return request({
        url: "/product/samplebook/list",
        method: "get",
        params: data,
    });
}
// 添加或修改产品样册
export function product_samplebook_save(data) {
    return request({
        url: "/product/samplebook/save",
        method: "post",
        data,
    });
}
// 删除产品样册
export function product_samplebook_del(data) {
    return request({
        url: "/product/samplebook/del",
        method: "post",
        data,
    });
}
// 添加质检报告
export function product_reports(data) {
    return request({
        url: "/product/reports",
        method: "post",
        data,
    });
}
// 选择产品属性
export function product_add_attribute(data) {
    return request({
        url: "/product/add_attribute",
        method: "post",
        data,
    });
}
// 属性内容列表
export function product_attribute_content_list(data) {
    return request({
        url: "/product/attribute/content/list",
        method: "get",
        params: data,
    });
}
// 创建或修改属性内容
export function product_attribute_content_save(data) {
    return request({
        url: "/product/attribute/content/save",
        method: "post",
        data,
    });
}
// 删除属性内容
export function product_attribute_content_del(data) {
    return request({
        url: "/product/attribute/content/del",
        method: "post",
        data,
    });
}
// 修改产品分类状态
export function product_type_disable(data) {
    return request({
        url: "/product/type/disable",
        method: "post",
        data,
    });
}
// 门店列表
export function store_list(data) {
    return request({
        url: "/store/list",
        method: "get",
        params: data,
    });
}
// 代理商列表
export function agent_list(data) {
    return request({
        url: "/agent/list",
        method: "get",
        params: data,
    });
}
// 城市数据
export function other_citys(data) {
    return request({
        url: "/other/citys",
        method: "get",
        params: data,
    });
}
// 创建或修改代理商
export function agent_save(data) {
    return request({
        url: "/agent/save",
        method: "post",
        data,
    });
}
// 删除代理商
export function agent_delete(data) {
    return request({
        url: "/agent/delete",
        method: "post",
        data,
    });
}
// 获取代理商默认编号
export function agent_number(data) {
    return request({
        url: "/agent/number",
        method: "get",
        params: data,
    });
}
// 修改代理商状态
export function agent_status(data) {
    return request({
        url: "/agent/status",
        method: "post",
        data,
    });
}
// 代理商等级列表
export function agent_level_list(data) {
    return request({
        url: "/agent/level/list",
        method: "get",
        params: data,
    });
}
// 创建或修改等级
export function agent_level_save(data) {
    return request({
        url: "/agent/level/save",
        method: "post",
        data,
    });
}
// 删除等级
export function agent_level_delete(data) {
    return request({
        url: "/agent/level/delete",
        method: "post",
        data,
    });
}
// 创建或修改门店
export function store_save(data) {
    return request({
        url: "/store/save",
        method: "post",
        data,
    });
}
// 修改门店状态
export function store_status(data) {
    return request({
        url: "/store/status",
        method: "post",
        data,
    });
}
// 删除门店
export function store_delete(data) {
    return request({
        url: "/store/delete",
        method: "post",
        data,
    });
}
// 门店类型列表
export function store_type_list(data) {
    return request({
        url: "/store/type/list",
        method: "get",
        params: data,
    });
}
// 创建或修改门店类型
export function store_type_save(data) {
    return request({
        url: "/store/type/save",
        method: "post",
        data,
    });
}
// 删除门店类型
export function store_type_delete(data) {
    return request({
        url: "/store/type/delete",
        method: "post",
        data,
    });
}
// 溯源实例列表
export function example_list(data) {
    return request({
        url: "/example/list",
        method: "get",
        params: data,
    });
}
// 创建或修改溯源实例
export function example_save(data) {
    return request({
        url: "/example/save",
        method: "post",
        data,
    });
}
// 删除溯源实例
export function example_delete(data) {
    return request({
        url: "/example/delete",
        method: "post",
        data,
    });
}
// 模块列表
export function example_module_list(data) {
    return request({
        url: "/example/module/list",
        method: "get",
        params: data,
    });
}
// 删除模块
export function example_module_delete(data) {
    return request({
        url: "/example/module/delete",
        method: "post",
        data,
    });
}
// 节点列表
export function example_node_list(data) {
    return request({
        url: "/example/node/list",
        method: "get",
        params: data,
    });
}
// 创建或修改节点
export function example_node_save(data) {
    return request({
        url: "/example/node/save",
        method: "post",
        data,
    });
}
// 节点详情
export function example_node_info(data) {
    return request({
        url: "/example/node/info",
        method: "get",
        params: data,
    });
}
// 删除节点
export function example_node_delete(data) {
    return request({
        url: "/example/node/delete",
        method: "post",
        data,
    });
}
// 关联产品列表
export function example_product_list(data) {
    return request({
        url: "/example/product/list",
        method: "get",
        params: data,
    });
}
// 关联批次列表
export function example_batch_list(data) {
    return request({
        url: "/example/batch/list",
        method: "get",
        params: data,
    });
}
// 创建产品关联
export function example_product_save(data) {
    return request({
        url: "/example/product/save",
        method: "post",
        data,
    });
}
// 创建批次关联
export function example_batch_save(data) {
    return request({
        url: "/example/batch/save",
        method: "post",
        data,
    });
}
// 删除产品关联
export function example_product_delete(data) {
    return request({
        url: "/example/product/delete",
        method: "post",
        data,
    });
}
// 删除批次关联
export function example_batch_delete(data) {
    return request({
        url: "/example/batch/delete",
        method: "post",
        data,
    });
}
// 创建溯源码生成记录
export function qrcode_count_create(data) {
    return request({
        url: "/qrcode/count/create",
        method: "post",
        data,
    });
}
// 删除溯源码生成记录
export function qrcode_count_delete(data) {
    return request({
        url: "/qrcode/count/delete",
        method: "post",
        data,
    });
}
// 重新生成
export function qrcode_count_refresh(data) {
    return request({
        url: "/qrcode/count/refresh",
        method: "post",
        data,
    });
}
// 编辑溯源码生成记录
export function qrcode_count_edit(data) {
    return request({
        url: "/qrcode/count/edit",
        method: "post",
        data,
    });
}
// 溯源码生成记录详情
export function qrcode_count_info(data) {
    return request({
        url: "/qrcode/count/info",
        method: "get",
        params: data,
    });
}
// 溯源码列表
export function qrcode_list(data) {
    return request({
        url: "/qrcode/list",
        method: "get",
        params: data,
    });
}
// 溯源码详情
export function qrcode_info(data) {
    return request({
        url: "/qrcode/info",
        method: "get",
        params: data,
    });
}
// 编辑溯源码
export function qrcode_edit(data) {
    return request({
        url: "/qrcode/edit",
        method: "post",
        data,
    });
}
// 删除溯源码
export function qrcode_delete(data) {
    return request({
        url: "/qrcode/delete",
        method: "post",
        data,
    });
}
// 导出记录
export function export_list(data) {
    return request({
        url: "/export/list",
        method: "get",
        params: data,
    });
}
// 导出记录
export function packing_export_list(data) {
    return request({
        url: "/packing/export/list",
        method: "get",
        params: data,
    });
}
// 导出溯源码
export function export_qrcode(data) {
    return request({
        url: "/export/qrcode",
        method: "post",
        data,
    });
}
// 获取公司信息
export function system_company_index(data) {
    return request({
        url: "/system/company/index",
        method: "get",
        params: data,
    });
}
// 保存企业信息接口
export function system_company_save(data) {
    return request({
        url: "/system/company/save",
        method: "post",
        data,
    });
}
// 窜货防伪设置
export function system_security_index(data) {
    return request({
        url: "/system/security/index",
        method: "get",
        params: data,
    });
}
// 保存窜货防伪设置
export function system_security_save(data) {
    return request({
        url: "/system/security/save",
        method: "post",
        data,
    });
}
// 获取公众号与支付接口
export function system_wx_index(data) {
    return request({
        url: "/system/wx/index",
        method: "get",
        params: data,
    });
}
// 保存公众号与支付接口
export function system_wx_save(data) {
    return request({
        url: "/system/wx/save",
        method: "post",
        data,
    });
}
// 红包列表
export function assembly_wxpacket_list(data) {
    return request({
        url: "/assembly/wxpacket/list",
        method: "get",
        params: data,
    });
}
// 红包状态修改
export function assembly_wxpacket_status(data) {
    return request({
        url: "/assembly/wxpacket/status",
        method: "post",
        data,
    });
}
// 红包删除
export function assembly_wxpacket_delete(data) {
    return request({
        url: "/assembly/wxpacket/delete",
        method: "post",
        data,
    });
}
// 详情
export function assembly_wxpacket_info(data) {
    return request({
        url: "/assembly/wxpacket/info",
        method: "get",
        params: data,
    });
}
// 创建红包活动
export function assembly_wxpacket_save(data) {
    return request({
        url: "/assembly/wxpacket/save",
        method: "post",
        data,
    });
}
// 获取预警信息未读总数
export function home_news_count(data) {
    return request({
        url: "/home/news_count",
        method: "get",
        params: data,
    });
}
// 创建外箱码生成记录
export function packing_count_create(data) {
    return request({
        url: "/packing/count/create",
        method: "post",
        data,
    });
}
// 导出外箱码
export function packing_export_qrcode(data) {
    return request({
        url: "/packing/export/qrcode",
        method: "post",
        data,
    });
}
// 外箱码生成记录列表
export function packing_count_list(data) {
    return request({
        url: "/packing/count/list",
        method: "get",
        params: data,
    });
}
// 外箱码列表
export function packing_list(data) {
    return request({
        url: "/packing/list",
        method: "get",
        params: data,
    });
}
// 产品装小箱列表
export function packing_small_list(data) {
    return request({
        url: "/packing/small/list",
        method: "get",
        params: data,
    });
}
// 小箱中产品列表
export function packing_small_product(data) {
    return request({
        url: "/packing/small/product",
        method: "get",
        params: data,
    });
}
// 删除
export function packing_small_delete(data) {
    return request({
        url: "/packing/small/delete",
        method: "post",
        data,
    });
}
// 产品装小箱（补充装箱is_exist设置为1）
export function packing_small_tostart(data) {
    return request({
        url: "/packing/small/tostart",
        method: "post",
        data,
    });
}
// 随机生成箱码
export function packing_count_round(data) {
    return request({
        url: "/packing/count/round",
        method: "get",
        params: data,
    });
}
// 拆箱
export function packing_unpack(data) {
    return request({
        url: "/packing/unpack",
        method: "post",
        data,
    });
}
// 小箱装大箱列表
export function packing_big_list(data) {
    return request({
        url: "/packing/big/list",
        method: "get",
        params: data,
    });
}
// 小箱装大箱（补充装箱is_exist设置为1）
export function packing_big_tostart(data) {
    return request({
        url: "/packing/big/tostart",
        method: "post",
        data,
    });
}
// 大箱中小箱列表
export function packing_big_small(data) {
    return request({
        url: "/packing/big/small",
        method: "get",
        params: data,
    });
}
// 大箱中产品列表
export function packing_big_product(data) {
    return request({
        url: "/packing/big/product",
        method: "get",
        params: data,
    });
}
// 日志列表
export function packing_log_list(data) {
    return request({
        url: "/packing/log/list",
        method: "post",
        data,
    });
}
// 智能装箱记录
export function packing_intelligence_lis(data) {
    return request({
        url: "/packing/intelligence_lis",
        method: "get",
        params: data,
    });
}
// 仓库列表
export function warehouse_list(data) {
    return request({
        url: "/warehouse/list",
        method: "get",
        params: data,
    });
}
// 新建或者修改仓库
export function warehouse_save(data) {
    return request({
        url: "/warehouse/save",
        method: "post",
        data,
    });
}
// 删除仓库
export function warehouse_delete(data) {
    return request({
        url: "/warehouse/delete",
        method: "post",
        data,
    });
}
// 调拨入库
export function warehouse_transfer(data) {
    return request({
        url: "/warehouse/transfer",
        method: "post",
        data,
    });
}
// 查询溯源码
export function warehouse_search(data) {
    return request({
        url: "/warehouse/search",
        method: "post",
        data,
    });
}
// 调拨日志
export function warehouse_log(data) {
    return request({
        url: "/warehouse/log",
        method: "post",
        data,
    });
}
// 重新操作
export function warehouse_refresh(data) {
    return request({
        url: "/warehouse/refresh",
        method: "post",
        data,
    });
}
// DIY模板的页面管理-diy模板内容页
export function template_diy_manage_info(data) {
    return request({
        url: "/template/diy/manage_info",
        method: "get",
        params: data,
    });
}
// 总部库存明细
export function warehouse_headquarters_list(data) {
    return request({
        url: "/warehouse/headquarters/list",
        method: "get",
        params: data,
    });
}
// 总部库存单个商品的溯源码列表
export function warehouse_headquarters_product(data) {
    return request({
        url: "/warehouse/headquarters/product",
        method: "get",
        params: data,
    });
}
// 代理商库存明细
export function warehouse_agent_list(data) {
    return request({
        url: "/warehouse/agent/list",
        method: "get",
        params: data,
    });
}
// 单个代理商的溯源码列表
export function warehouse_agent_qrcode(data) {
    return request({
        url: "/warehouse/agent/qrcode",
        method: "get",
        params: data,
    });
}
// 门店库存明细
export function warehouse_store_list(data) {
    return request({
        url: "/warehouse/store/list",
        method: "get",
        params: data,
    });
}
// 单门店库存明细
export function warehouse_store_qrcode(data) {
    return request({
        url: "/warehouse/store/qrcode",
        method: "get",
        params: data,
    });
}
// 库存统计分析
export function warehouse_all_qrcode(data) {
    return request({
        url: "/warehouse/all_qrcode",
        method: "get",
        params: data,
    });
}
// 主动发货退货
export function incoming_coming(data) {
    return request({
        url: "/incoming/coming",
        method: "post",
        data,
    });
}
// 发货退货记录列表
export function incoming_list(data) {
    return request({
        url: "/incoming/list",
        method: "get",
        params: data,
    });
}
// 删除发货退货记录
export function incoming_delete(data) {
    return request({
        url: "/incoming/delete",
        method: "get",
        params: data,
    });
}
// 记录详情里的商品溯源码列表
export function incoming_info(data) {
    return request({
        url: "/incoming/info",
        method: "get",
        params: data,
    });
}
// 退回操作
export function incoming_back(data) {
    return request({
        url: "/incoming/back",
        method: "post",
        data,
    });
}
// 流程物流记录
export function incoming_qrcode_all(data) {
    return request({
        url: "/incoming/qrcode_all",
        method: "get",
        params: data,
    });
}
// 录入物流信息
export function incoming_enter(data) {
    return request({
        url: "/incoming/enter",
        method: "post",
        data,
    });
}
// 账户列表
export function account_list(data) {
    return request({
        url: "/account/list",
        method: "get",
        params: data,
    });
}
// 创建账户
export function account_save(data) {
    return request({
        url: "/account/save",
        method: "post",
        data,
    });
}
// 修改账户状态
export function account_status(data) {
    return request({
        url: "/account/status",
        method: "post",
        data,
    });
}
// 删除账户
export function account_delete(data) {
    return request({
        url: "/account/delete",
        method: "post",
        data,
    });
}
// 角色列表
export function account_roles_list(data) {
    return request({
        url: "/account/roles/list",
        method: "get",
        params: data,
    });
}
// 创建或修改角色
export function account_roles_create(data) {
    return request({
        url: "/account/roles/create",
        method: "post",
        data,
    });
}
// 角色详情
export function account_roles_info(data) {
    return request({
        url: "/account/roles/info",
        method: "get",
        params: data,
    });
}
// 所有菜单
export function account_roles_menus(data) {
    return request({
        url: "/account/roles/menus",
        method: "get",
        params: data,
    });
}
// 删除角色
export function account_roles_delete(data) {
    return request({
        url: "/account/roles/delete",
        method: "post",
        data,
    });
}
// 物流列表
export function incoming_logistics(data) {
    return request({
        url: "/incoming/logistics",
        method: "get",
        params: data,
    });
}
// 删除物流信息
export function incoming_logistics_del(data) {
    return request({
        url: "/incoming/logistics_del",
        method: "post",
        data,
    });
}
// 批量修改溯源码
export function qrcode_batch_edit(data) {
    return request({
        url: "/qrcode/batch_edit",
        method: "post",
        data,
    });
}
// 红包领取记录
export function assembly_wxpacket_prize(data) {
    return request({
        url: "/assembly/wxpacket/prize",
        method: "get",
        params: data,
    });
}
// 重新发放
export function assembly_wxpacket_refresh(data) {
    return request({
        url: "/assembly/wxpacket/refresh",
        method: "post",
        data,
    });
}
// 获取查询模板内容
export function template_query_content(data) {
    return request({
        url: "/template/query_content",
        method: "get",
        params: data,
    });
}
// 修改查询模板内容
export function template_modify_query(data) {
    return request({
        url: "/template/modify_query",
        method: "post",
        data,
    });
}
// 修改右上角信息
export function account_modify_info(data) {
    return request({
        url: "/account/modify_info",
        method: "post",
        data,
    });
}
// DIY模板的页面管理-设置默认首页
export function template_diy_set(data) {
    return request({
        url: "/template/diy/set",
        method: "post",
        data,
    });
}
// 通过token登录
export function tokens(data) {
    return request({
        url: "/token",
        method: "post",
        data,
    });
}
// 标记所有为已读
export function home_read_all(data) {
    return request({
        url: "/home/read_all",
        method: "post",
        data,
    });
}
// 获取需要填写的批次属性
export function batch_attr_list(data) {
    return request({
        url: "/batch/attr_list",
        method: "post",
        data,
    });
}
// 选择批次属性
export function batch_add_attribute(data) {
    return request({
        url: "/batch/add_attribute",
        method: "post",
        data,
    });
}
// 瑶定制导入
export function other_special_import(data) {
    return request({
        url: "/other/special_import",
        method: "get",
        params: data,
    });
}
// 添加批次质检报告
export function batch_reports(data) {
    return request({
        url: "/batch/reports",
        method: "post",
        data,
    });
}
// 产品装小箱时筛选溯源码
export function qrcode_filter(data) {
    return request({
        url: "/qrcode/filter",
        method: "get",
        params: data,
    });
}
// 小箱装大箱时筛选小箱
export function packing_filter(data) {
    return request({
        url: "/packing/filter",
        method: "get",
        params: data,
    });
}
// 获取diy产品属性相关的页面
export function attr_page(data) {
    return request({
        url: "/template/diy/attr_page",
        method: "get",
        params: data,
    });
}
// 获取某页面的所有属性
export function page_attrs(data) {
    return request({
        url: "/template/diy/page_attrs",
        method: "get",
        params: data,
    });
}
// 保存该页面的产品属性
export function save_page_attrs(data) {
    return request({
        url: "/template/diy/save_page_attrs",
        method: "post",
        data,
    });
}
// 版本更新日志列表
export function version_index(data) {
    return request({
        url: "/log/version/index",
        method: "get",
        params: data,
    });
}
// 操作日志
export function action_index(data) {
    return request({
        url: "/log/action/index",
        method: "get",
        params: data,
    });
}
// 获取登录验证码
export function login_yzm(data) {
    return request({
        url: "/login_yzm",
        method: "post",
        data,
    });
}
// 通过验证码登录
export function yzm_login(data) {
    return request({
        url: "/yzm_login",
        method: "post",
        data,
    });
}
// 修改序号
export function example_module_sort(data) {
    return request({
        url: "/example/module/sort",
        method: "post",
        data,
    });
}
export function example_node_sort(data) {
    return request({
        url: "/example/node/sort",
        method: "get",
        params: data,
    });
}
// 用户列表
export function customer(data) {
    return request({
        url: "/customer",
        method: "get",
        params: data,
    });
}
// 修改用户信息
export function customer_save(data) {
    return request({
        url: "/customer/save",
        method: "post",
        data,
    });
}
// 删除用户信息
export function customer_del(data) {
    return request({
        url: "/customer/del",
        method: "post",
        data,
    });
}
// 用户售后信息列表
export function customer_sales(data) {
    return request({
        url: "/customer/sales",
        method: "get",
        params: data,
    });
}
// 修改用户售后信息
export function customer_sales_save(data) {
    return request({
        url: "/customer/sales/save",
        method: "post",
        data,
    });
}
// 版本列表
export function version(data) {
    return request({
        url: "/version",
        method: "get",
        params: data,
    });
}
// 购买版本
export function version_buy(data) {
    return request({
        url: "/version/buy",
        method: "post",
        data,
    });
}
// 查询订单状态
export function version_query(data) {
    return request({
        url: "/version/query",
        method: "post",
        data,
    });
}
// 获取账户版本信息
export function account_version(data) {
    return request({
        url: "/account/version",
        method: "get",
        params: data,
    });
}
// 获取账户版本模块关联
export function account_v_m(data) {
    return request({
        url: "/account/v_m",
        method: "get",
        params: data,
    });
}
// 用户售后信息
export function customer_sales_info(data) {
    return request({
        url: "/customer/sales/info",
        method: "get",
        params: data,
    });
}
// 切换模板接口（批次）
export function batch_change_template(data) {
    return request({
        url: "/batch/change_template",
        method: "post",
        data,
    });
}
// 模块列表
export function module_list(data) {
    return request({
        url: "/module",
        method: "get",
        params: data,
    });
}
// 保存或者修改模块
export function module_save(data) {
    return request({
        url: "/module/save",
        method: "post",
        data,
    });
}
// 删除模块
export function module_del(data) {
    return request({
        url: "/module/del",
        method: "post",
        data,
    });
}
// 节点下拉
export function module_node_select(data) {
    return request({
        url: "/module/node/select",
        method: "get",
        params: data,
    });
}
// 删除节点
export function module_node_del(data) {
    return request({
        url: "/module/node/del",
        method: "post",
        data,
    });
}
// 产品下拉
export function product_select(data) {
    return request({
        url: "/product/select",
        method: "get",
        params: data,
    });
}
// 批次下拉
export function batch_select(data) {
    return request({
        url: "/batch/select",
        method: "get",
        params: data,
    });
}
// 行业下拉
export function other_industry_list(data) {
    return request({
        url: "/other/industry_list",
        method: "get",
        params: data,
    });
}
// 获取产品分类下拉
export function product_type_select(data) {
    return request({
        url: "/product/type/select",
        method: "get",
        params: data,
    });
}
// 产品属性下拉
export function product_attribute_select(data) {
    return request({
        url: "/product/attribute/select",
        method: "get",
        params: data,
    });
}
// 代理商下拉
export function agent_select(data) {
    return request({
        url: "/agent/select",
        method: "get",
        params: data,
    });
}
// 代理商等级下拉
export function agent_level_select(data) {
    return request({
        url: "/agent/level/select",
        method: "get",
        params: data,
    });
}
// 门店类型下拉
export function store_type_select(data) {
    return request({
        url: "/store/type/select",
        method: "get",
        params: data,
    });
}
// 外箱码生成记录下拉（批次下拉）
export function packing_count_select(data) {
    return request({
        url: "/packing/count/select",
        method: "get",
        params: data,
    });
}
// 仓库下拉
export function warehouse_select(data) {
    return request({
        url: "/warehouse/select",
        method: "get",
        params: data,
    });
}
// 门店下拉
export function store_select(data) {
    return request({
        url: "/store/select",
        method: "get",
        params: data,
    });
}
// 物流公司下拉
export function incoming_select(data) {
    return request({
        url: "/incoming/select",
        method: "post",
        data,
    });
}
// 角色下拉
export function account_roles_select(data) {
    return request({
        url: "/account/roles/select",
        method: "get",
        params: data,
    });
}
// DIY模板的页面管理- diy下拉页
export function diy_manage_select(data) {
    return request({
        url: "/template/diy/manage_select",
        method: "get",
        params: data,
    });
}
// 所属账户下拉
export function account_store_select(data) {
    return request({
        url: "/account/store_select",
        method: "get",
        params: data,
    });
}
// 模块下拉
export function module_select(data) {
    return request({
        url: "/module/select",
        method: "get",
        params: data,
    });
}
// 节点列表
export function module_node(data) {
    return request({
        url: "/module/node",
        method: "get",
        params: data,
    });
}
// 保存或者修改节点
export function module_node_save(data) {
    return request({
        url: "/module/node/save",
        method: "post",
        data,
    });
}
// 门店关联列表
export function store_relation_list(data) {
    return request({
        url: "/store/relation_list",
        method: "get",
        params: data,
    });
}
// 代理商关联列表
export function agent_relation_list(data) {
    return request({
        url: "/agent/relation_list",
        method: "get",
        params: data,
    });
}
// 产品关联列表
export function product_relation_list(data) {
    return request({
        url: "/product/relation_list",
        method: "get",
        params: data,
    });
}
// 关联代理商
export function account_relation_agent(data) {
    return request({
        url: "/account/relation/agent",
        method: "post",
        data,
    });
}
// 关联门店
export function account_relation_store(data) {
    return request({
        url: "/account/relation/store",
        method: "post",
        data,
    });
}
// 关联产品
export function account_relation_product(data) {
    return request({
        url: "/account/relation/product",
        method: "post",
        data,
    });
}
// 代理商导出
export function agent_export(data) {
    return request({
        url: "/agent/export",
        method: "get",
        params: data,
    });
}
// 导出门店
export function store_export(data) {
    return request({
        url: "/store/export",
        method: "get",
        params: data,
    });
}
// 主账户配置信息
export function account_info(data) {
    return request({
        url: "/account/info",
        method: "get",
        params: data,
    });
}
// 设置是否审核
export function account_store_review(data) {
    return request({
        url: "/account/store_review",
        method: "post",
        data,
    });
}
// 溯源码套餐列表
export function version_qrcode(data) {
    return request({
        url: "/version/qrcode",
        method: "get",
        params: data,
    });
}
// 购买溯源码版本
export function version_qrcode_buy(data) {
    return request({
        url: "/version/qrcode/buy",
        method: "post",
        data,
    });
}
// 版本的订单列表
export function version_order(data) {
    return request({
        url: "/version/order",
        method: "get",
        params: data,
    });
}
// 版本对比列表
export function version_compare(data) {
    return request({
        url: "/version/compare",
        method: "get",
        params: data,
    });
}
// 插件列表
export function apps_list(data) {
    return request({
        url: "/apps",
        method: "get",
        params: data,
    });
}
// 插件版本详情
export function apps_info(data) {
    return request({
        url: "/apps/info",
        method: "get",
        params: data,
    });
}
// 购买插件版本
export function apps_buy(data) {
    return request({
        url: "/apps/buy",
        method: "post",
        data,
    });
}
// 文章详情
export function article_info(data) {
    return request({
        url: "/article/info",
        method: "get",
        params: data,
    });
}
// 修改文章状态
export function article_status(data) {
    return request({
        url: "/article/status",
        method: "post",
        data,
    });
}
// 文章排序
export function article_sort(data) {
    return request({
        url: "/article/sort",
        method: "get",
        params: data,
    });
}
// 创建文章
export function article_save(data) {
    return request({
        url: "/article/save",
        method: "post",
        data,
    });
}
// 删除文章
export function article_delete(data) {
    return request({
        url: "/article/delete",
        method: "post",
        data,
    });
}
// 文章列表
export function article_list(data) {
    return request({
        url: "/article/list",
        method: "get",
        params: data,
    });
}
// 商品列表
export function points_goods(data) {
    return request({
        url: "/points/goods",
        method: "get",
        params: data,
    });
}
// 排序
export function points_goods_sort(data) {
    return request({
        url: "/points/goods/sort",
        method: "get",
        params: data,
    });
}
// 详情
export function points_goods_infos(data) {
    return request({
        url: "/points/goods/infos",
        method: "get",
        params: data,
    });
}
// 创建或修改
export function points_goods_save(data) {
    return request({
        url: "/points/goods/save",
        method: "post",
        data,
    });
}
// 订单详情
export function points_order_info(data) {
    return request({
        url: "/points/order/info",
        method: "get",
        params: data,
    });
}
// 设置配送信息
export function points_order_delivery(data) {
    return request({
        url: "/points/order/delivery",
        method: "post",
        data,
    });
}
// 积分商城订单
export function points_order(data) {
    return request({
        url: "/points/order",
        method: "get",
        params: data,
    });
}
// 设置兑换或配送状态
export function points_order_status(data) {
    return request({
        url: "/points/order/status",
        method: "post",
        data,
    });
}
// 删除商品
export function points_goods_delete(data) {
    return request({
        url: "/points/goods/delete",
        method: "post",
        data,
    });
}
// 删除订单
export function points_order_delete(data) {
    return request({
        url: "/points/order/delete",
        method: "post",
        data,
    });
}
// 导购员列表
export function shopping_wxpacket(data) {
    return request({
        url: "/shopping/wxpacket",
        method: "get",
        params: data,
    });
}
// 添加导购员
export function shopping_wxpacket_save(data) {
    return request({
        url: "/shopping/wxpacket/save",
        method: "post",
        data,
    });
}
// 删除导购员
export function shopping_wxpacket_delete(data) {
    return request({
        url: "/shopping/wxpacket/delete",
        method: "post",
        data,
    });
}
// 添加导购员溯源码
export function shopping_wxpacket_add_qrcode(data) {
    return request({
        url: "/shopping/wxpacket/add_qrcode",
        method: "post",
        data,
    });
}
// 通过号段查询码
export function shopping_wxpacket_search_qrcode(data) {
    return request({
        url: "/shopping/wxpacket/search_qrcode",
        method: "post",
        data,
    });
}
// 获取导购员码详情
export function shopping_wxpacket_infos(data) {
    return request({
        url: "/shopping/wxpacket/infos",
        method: "get",
        params: data,
    });
}
// 分类下拉
export function shopping_type_select(data) {
    return request({
        url: "/shopping/type/select",
        method: "get",
        params: data,
    });
}
// 导购员下拉
export function shopping_select(data) {
    return request({
        url: "/shopping/select",
        method: "get",
        params: data,
    });
}
// 导购员列表
export function shopping_list(data) {
    return request({
        url: "/shopping",
        method: "get",
        params: data,
    });
}
// 创建导购员
export function shopping_save(data) {
    return request({
        url: "/shopping/save",
        method: "post",
        data,
    });
}
// 删除导购员
export function shopping_delete(data) {
    return request({
        url: "/shopping/delete",
        method: "post",
        data,
    });
}
// 分类列表
export function shopping_type(data) {
    return request({
        url: "/shopping/type",
        method: "get",
        params: data,
    });
}
// 创建分类
export function shopping_type_save(data) {
    return request({
        url: "/shopping/type/save",
        method: "post",
        data,
    });
}
// 删除分类
export function shopping_type_delete(data) {
    return request({
        url: "/shopping/type/delete",
        method: "post",
        data,
    });
}
// 修改核销员状态（启用/禁用）
export function shopping_status(data) {
    return request({
        url: "/shopping/status",
        method: "post",
        data,
    });
}
// 获取核销记录列表
export function shopping_writeoff_list(data) {
    return request({
        url: "/shopping/writeoff/list",
        method: "get",
        params: data,
    });
}
// 用户下拉
export function customer_select(data) {
    return request({
        url: "/customer/select",
        method: "get",
        params: data,
    });
}
// 扫码领积分 活动列表
export function points_active(data) {
    return request({
        url: "/points/active",
        method: "get",
        params: data,
    });
}
// 扫码领积分 活动详情
export function points_active_info(data) {
    return request({
        url: "/points/active/info",
        method: "get",
        params: data,
    });
}
// 扫码领积分 创建或更新
export function points_active_save(data) {
    return request({
        url: "/points/active/save",
        method: "post",
        data,
    });
}
// 扫码领积分 更新状态
export function points_active_status(data) {
    return request({
        url: "/points/active/status",
        method: "post",
        data,
    });
}
// 扫码领积分 删除
export function points_active_delete(data) {
    return request({
        url: "/points/active/delete",
        method: "post",
        data,
    });
}
// 扫码领积分 领取列表
export function points_active_user_list(data) {
    return request({
        url: "/points/active/user/list",
        method: "get",
        params: data,
    });
}
// 获取配置
export function points_config(data) {
    return request({
        url: "/points/config",
        method: "get",
        params: data,
    });
}
// 获取banner
export function points_config_banner(data) {
    return request({
        url: "/points/config/banner",
        method: "get",
        params: data,
    });
}
// 保存配置
export function points_config_save_config(data) {
    return request({
        url: "/points/config/save_config",
        method: "post",
        data,
    });
}
// 保存banner
export function points_config_save_banner(data) {
    return request({
        url: "/points/config/save_banner",
        method: "post",
        data,
    });
}
// 已兑换列表
export function points_goods_order(data) {
    return request({
        url: "/points/goods/order",
        method: "get",
        params: data,
    });
}
// 创建文章分类
export function article_type_save(data) {
    return request({
        url: "/article/type/save",
        method: "post",
        data,
    });
}
// 删除文章分类
export function article_type_delete(data) {
    return request({
        url: "/article/type/delete",
        method: "post",
        data,
    });
}
// 获取文章分类
export function article_type(data) {
    return request({
        url: "/article/type",
        method: "get",
        params: data,
    });
}
// 获取文章分类下拉
export function article_type_select(data) {
    return request({
        url: "/article/type/select",
        method: "get",
        params: data,
    });
}
// 大转盘
// 活动列表
export function lottery_activity_index(data) {
    return request({
        url: "/lottery/activity/index",
        method: "get",
        params: data,
    });
}
// 活动详情
export function lottery_activity_detail(data) {
    return request({
        url: "/lottery/activity/detail",
        method: "get",
        params: data,
    });
}
// 创建/编辑活动
export function lottery_activity_save(data) {
    return request({
        url: "/lottery/activity/save",
        method: "post",
        data,
    });
}
// 切换活动状态
export function lottery_activity_toggle(data) {
    return request({
        url: "/lottery/activity/toggle",
        method: "post",
        data,
    });
}
// 删除活动
export function lottery_activity_delete(data) {
    return request({
        url: "/lottery/activity/delete",
        method: "post",
        data,
    });
}
// 保存奖品
export function lottery_prize_save(data) {
    return request({
        url: "/lottery/prize/save",
        method: "post",
        data,
    });
}
// 抽奖记录列表
export function lottery_record_index(data) {
    return request({
        url: "/lottery/record/index",
        method: "get",
        params: data,
    });
}
// 填写物流配送信息
export function lottery_record_update_delivery(data) {
    return request({
        url: "/lottery/record/update-delivery",
        method: "post",
        data,
    });
}
// 溯源码回收站列表
export function trash_qrcode_list(data) {
    return request({
        url: "/trash/qrcode/list",
        method: "get",
        params: data,
    });
}
// 溯源码彻底删除
export function trash_qrcode_forceDelete(data) {
    return request({
        url: "/trash/qrcode/forceDelete",
        method: "post",
        data,
    });
}
// 溯源码恢复
export function trash_qrcode_restore(data) {
    return request({
        url: "/trash/qrcode/restore",
        method: "post",
        data,
    });
}
// 箱码回收站列表
export function trash_box_list(data) {
    return request({
        url: "/trash/box/list",
        method: "get",
        params: data,
    });
}
// 箱码彻底删除
export function trash_box_forceDelete(data) {
    return request({
        url: "/trash/box/forceDelete",
        method: "post",
        data,
    });
}
// 箱码恢复
export function trash_box_restore(data) {
    return request({
        url: "/trash/box/restore",
        method: "post",
        data,
    });
}
// 订单列表
export function order_list(data) {
    return request({
        url: "/order/list",
        method: "get",
        params: data,
    });
}
// 订单详情
export function order_detail(data) {
    return request({
        url: "/order/detail",
        method: "get",
        params: data,
    });
}
// 删除订单
export function order_delete(data) {
    return request({
        url: "/order/delete",
        method: "post",
        data,
    });
}